import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-20 right-4 z-[90] bg-background border rounded-lg shadow-lg p-3 flex items-center gap-3 w-56"
}
const _hoisted_2 = { class: "flex-shrink-0 h-8 w-8 rounded bg-primary/10 flex items-center justify-center" }
const _hoisted_3 = { class: "flex items-center gap-1 flex-shrink-0" }

import { useTasksWidget } from '@/composables/useTasksWidget'
import { Button } from '@/components/ui/button'
import { CheckSquare, Maximize2, X } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'TasksWidget',
  setup(__props) {

const { isMinimized, restore, close } = useTasksWidget()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition-all duration-300 ease-out",
    "leave-active-class": "transition-all duration-200 ease-in",
    "enter-from-class": "opacity-0 translate-y-4 scale-95",
    "enter-to-class": "opacity-100 translate-y-0 scale-100",
    "leave-from-class": "opacity-100 translate-y-0 scale-100",
    "leave-to-class": "opacity-0 translate-y-4 scale-95"
  }, {
    default: _withCtx(() => [
      (_unref(isMinimized))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(CheckSquare), { class: "h-4 w-4 text-primary" })
            ]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-1 min-w-0" }, [
              _createElementVNode("p", { class: "text-sm font-medium truncate" }, "Mis Tareas"),
              _createElementVNode("p", { class: "text-xs text-muted-foreground" }, "Minimizado")
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Button), {
                variant: "ghost",
                size: "icon",
                class: "h-7 w-7",
                onClick: _unref(restore),
                title: "Restaurar"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Maximize2), { class: "h-3.5 w-3.5" })
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_unref(Button), {
                variant: "ghost",
                size: "icon",
                class: "h-7 w-7 text-muted-foreground hover:text-destructive",
                onClick: _unref(close),
                title: "Cerrar"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(X), { class: "h-3.5 w-3.5" })
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})